import React, { PureComponent, Fragment } from 'react';
import { Menu, Form, Dropdown } from 'semantic-ui-react';
import AnalysisDateMenu from 'modules/month-menu';

import TeacherAggregateTable from './teacher-table';

const WTD_ANALYSIS_WINDOW = 7;

const regionOptions = [
  { key: 'INDIA', value: 'INDIA', text: 'INDIA' },
  { key: 'USA', value: 'USA', text: 'USA' },
  { key: 'all', value: 'all', text: 'ALL' },
];

export default class TeacherAnalytics extends PureComponent {
  constructor(props) {
    super(props);
    var dateFrom = new Date();
    dateFrom.setDate(new Date().getDate() - WTD_ANALYSIS_WINDOW);
    this.state = {
      queryObj: {
        page: 1,
        page_size: 20,
        data_type: 'MTD',
      },
      searchTerm: '',
      loadCSV: false,
    };
  }

  handleChangeSearch = (e, { value }) => {
    this.setState({
      searchTerm: value,
    });
  };

  handleSubmitSearch = () => {
    const { queryObj, searchTerm } = this.state;
    let newQueryObj = Object.assign({}, queryObj);
    newQueryObj['query'] = searchTerm;
    this.setState({
      queryObj: newQueryObj,
    });
  };

  updateDates = (yrInit, yrFinal, mthInit, mthFinal, dataType) => {
    const { queryObj } = this.state;
    let newQueryObj = Object.assign({}, queryObj);
    newQueryObj['initial_month'] = yrInit + '-' + mthInit;
    newQueryObj['final_month'] = yrFinal + '-' + mthFinal;
    newQueryObj['data_type'] = dataType;
    this.setState({
      queryObj: newQueryObj,
    });
  };

  setPageNumberSizeSortedFiltered = (page, pageSize, sort, filter, loadCSV) => {
    const { queryObj } = this.state;
    let newQueryObj = Object.assign({}, queryObj);
    newQueryObj['page'] = page;
    newQueryObj['page_size'] = pageSize;
    if (sort) {
      newQueryObj['sort_field'] = sort.id;
      newQueryObj['sort_value'] = sort.desc ? -1 : 1;
    }
    if (filter && filter.length > 0) {
      newQueryObj['filter_field'] = filter.map(fl => fl.id).join('___');
      newQueryObj['filter_value'] = filter.map(fl => fl.value).join('___');
    }
    if (queryObj !== newQueryObj) {
      this.setState({
        queryObj: newQueryObj,
        loadCSV: loadCSV,
      });
    }
  };

  changeRegion = (event, { value }) => {
    const { queryObj } = this.state;
    let newQueryObj = Object.assign({}, queryObj);
    newQueryObj['student_region'] = value;
    this.setState({
      queryObj: newQueryObj,
    });
  };

  render() {
    const { queryObj, searchTerm, loadCSV } = this.state;

    return (
      <Fragment>
        <AnalysisDateMenu onUpdate={this.updateDates} />
        <Menu>
          <Menu.Item>
            <Dropdown
              style={{ minWidth: '7em' }}
              placeholder="Select Region"
              search
              value={queryObj.student_region}
              selection
              options={regionOptions}
              onChange={this.changeRegion}
            />
          </Menu.Item>
          <Menu.Item>
            <Form onSubmit={this.handleSubmitSearch}>
              <Form.Input
                size="large"
                icon="search"
                placeholder="Search for Teacher..."
                value={searchTerm}
                onChange={this.handleChangeSearch}
              />
            </Form>
          </Menu.Item>
        </Menu>
        <TeacherAggregateTable
          queryObj={queryObj}
          loadCSV={loadCSV}
          setPageNumberSizeSortedFiltered={this.setPageNumberSizeSortedFiltered}
        />
      </Fragment>
    );
  }
}
